import { createAction, props } from '@ngrx/store';

export const conversionToAmazonPaidSuccessful = createAction('[Conversion] Converted to Amazon Paid Account');
export const prepaidEnrollmentConversionClaimCodeError = createAction(
  '[Conversion] Claim Code Error',
  props<{ error: string | Error; claimCode?: string }>(),
);

export const showTimeoutModal = createAction('[Conversion] Show Timeout Alert Modal');
export const dismissTimeoutModal = createAction('[Conversion] Dismiss Timeout Alert Modal');
